export default "__VITE_ASSET__CxAXEzUj__"